<template>
    <v-content>
        <!--         Step Header         -->
        <v-row
            style="font-size: 1em; font-weight: 400; color: #212121; letter-spacing: 1px;"
            no-gutters
        >
            <v-col
                class="mx-3 text-center"
            >
                Please verify your email
            </v-col>
        </v-row>
        <v-row
            justify="center"
            style="font-size: 1.2em; font-weight: 600; color: #212121; letter-spacing: 1px;"
            no-gutters
        >
            <v-col
                class="mx-3 mt-2 mb-7 text-center"
            >
                Click Link in Your Email
            </v-col>
        </v-row>

    <!--            Input            -->
        <div
            class="bg5"
        >
            <v-row
                justify="center"
                no-gutters
            >
                <v-col
                    cols="12"
                    xs="12"
                    sm="10"
                    md="6"
                    lg="5"
                    xl="4"
                >
                    <v-row
                        justify="center"
                        class="my-4"
                        no-gutters
                    >
                        <v-text-field
                            v-model="credentials[0]"
                            label="Email"
                            @keydown.enter="signIn"
                            solo
                        />
                    </v-row>
                    <v-row
                        justify="center"
                        class="my-4"
                        no-gutters
                    >
                    <v-text-field
                        v-model="credentials[1]"
                        label="Password"
                        type="password"
                        @keydown.enter="signIn"
                        solo
                    />
                    </v-row>

    <!--          Navigation         -->
                    <v-row
                        no-gutters
                        class="mx-5"
                        justify="space-between"
                    >
                    <v-btn
                        class="btn2 mr-2"
                        @click.prevent="resendVerification"
                        color = #74cf74
                    >
                        Resend
                    </v-btn>
                    <v-btn
                        class="btn2 ml-2"
                        color = #74cf74
                        @click.prevent="signIn"
                        :disabled="disableStep5Next"
                    >
                        Continue
                    </v-btn>
                    </v-row>
                    <v-row
                    no-gutters
                    >
                        <v-col
                            class="text-right mt-1 pt-0 mx-5 red--text caption"
                        >
                            <v-row
                                justify="center"
                                no-gutters
                            >
                            <v-col
                                class="text-right ma-0 pa-0"
                            >
                                {{errorMessage1}}
                            </v-col>
                            </v-row>
                            <v-row
                                no-gutters
                            >
                                <v-col
                                    class="text-right ma-0 pa-0"
                                >
                                    {{errorMessage2}}
                                </v-col>
                            </v-row>
                            <v-row
                                no-gutters
                            >
                                <v-col
                                    class="text-right ma-0 pa-0"
                                >
                                    {{errorMessage3}}
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-content>
</template>


<script>
    import { Auth } from 'aws-amplify'

    export default {

        data: () => ({
            errorMessage1: null,
            errorMessage2: null,
            errorMessage3: null,
            resendCodeMessage: null,
        }),

        methods: {
            next() {
                this.stepper = this.stepper + 1
            },

            signIn() {
                this.errorMessage1 = null;
                this.errorMessage2 = null;
                this.errorMessage3 = null;

                Auth.signIn({
                    username: this.credentials[0],
                    password: this.credentials[1]
                })
                .then(
                    user => {
                        console.log('user:',user);
                        this.$store.dispatch('data/updateUser',user);
                        this.$store.dispatch('login/signIn',this.credentials[0]);
                        if (user.attributes['custom:status'] == 'new') {
                            this.$store.dispatch('data/updateAccountStatus','verified')
                        }
                        this.$store.dispatch('data/clearCredentials');
                        this.stepper = this.stepper + 1;
                        
                        this.$store.dispatch('data/generateMenu',this.menuStartDate);
                    }
                ).catch(
                    error => {
                        console.log(error);
                        this.processingSubmit = false;
                        if(error.message == "User is not confirmed.") {
                            this.errorMessage1 = "Email not verified, please click verification link in your email";
                            this.$store.dispatch('login/showConfirmUser',true);
                        } else {
                            this.errorMessage1 = "Incorrect username or password";
                        }
                    }
                )
            },

            resendVerification() {
                this.resendCodeMessage = null;
                
                Auth.resendSignUp(this.username)
                .then(
                    data => {
                        console.log('code resent successfully');
                        this.resendCodeMessage = 'Code sent to ';
                        this.resendCodeMessage += data.CodeDeliveryDetails.Destination
                    }
                ).catch(
                    error => {
                        console.log(error);
                    }
                )
            }

        },

        computed: {
            stepper: {
                get() {
                    return this.$store.getters['data/stepper'];
                },
                set(value) {
                    this.$store.dispatch('data/updateStepper',value);
                }
            },

            disableStep5Next() {
                if(this.credentials[0] == null | this.credentials[0] == '' | this.credentials[1] == null | this.credentials[1] == '') {
                    return true
                } else {
                    return false
                }
            },

            credentials(){
                return this.$store.getters['data/credentials'];
            },

            menuStartDate() {
                let now = new Date();
                let date = (now .getMonth() + 1) + "/" + ((now .getDate()) + (7- now .getDay())) + "/" + (now .getFullYear());
                return date
            },

        },
    }
</script>

<style scoped>
  .btn2 {
    font-family: "Noto Serif TC", serif;
    font-size: 0.9em;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }

  .btn3 {
    font-size: 0.9em;
    width: 100%;
    min-height: 48px;
    font-weight: 400;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: #74cf74 !important;
    font-weight: 600;
  }
</style>
